import { EntityBase } from "./EntityBase";
import { User } from "./User";
import { Account } from "./Account";
import { ContractStatus } from "../obj/ContractStatus";


export abstract class Contract extends EntityBase {
       user: User = null!;
       supplierName: string = null!;
       price: number = null!;
       accounts: Account[] = null!;
       termFrom: Date = null!;
       termTo: Date = null!;
       timeIndicator: number = null!;
       isNewRecord: boolean = false;
       status: ContractStatus;

       abstract getSalesPrice(): number;

       isCancelled(): boolean {
          if (this.status == ContractStatus.DECLINED_BY_SELLER || this.status == ContractStatus.DECLINED_BY_BUYER || this.status == ContractStatus.DECLINED_VERIFICATION_TIMEOUT) {
             return true;
          }
          return false;
       }
}
